document.addEventListener('DOMContentLoaded', function () {
  const specDataScript = document.getElementById('variant-spec-table');
  if (!specDataScript) return;

  let specData = {};
  try {
    specData = JSON.parse(specDataScript.textContent || '{}');
  } catch (e) {
    console.error('❌ Failed to parse variant spec data', e);
  }

  function updateSpecs(variantId) {
    if (!variantId || !specData[variantId]) return;
    const data = specData[variantId];

    const bladeElS1 = document.getElementById('bladeColor1');
    if (bladeElS1 && data.bladeColor1) {
      bladeElS1.textContent = data.bladeColor1;
    }

    const bladeMt = document.getElementById('bladeMaterial');
    if (bladeMt && data.bladeMaterial) {
      bladeMt.textContent = data.bladeMaterial;
    }

    const bladeRev = document.getElementById('bladeReverse');
    if (bladeRev && data.bladeReverse) {
      bladeRev.textContent = data.bladeReverse;
    }

    const motorEl = document.getElementById('housingColor');
    if (motorEl && data.housingColor) {
      motorEl.textContent = data.housingColor;
    }

    const motorFaminlyEl = document.getElementById('housingFamily');
    if (motorFaminlyEl && data.housingFamily) {
      motorFaminlyEl.textContent = data.housingFamily;
    }
  }

  let lastVariantId = null;
  function checkVariantChange() {
    const currentId = new URLSearchParams(window.location.search).get('variant');
    if (currentId && currentId !== lastVariantId) {
      lastVariantId = currentId;
      updateSpecs(currentId);
    }
  }

  checkVariantChange();
  setInterval(checkVariantChange, 300); 
});
